<template>
  <div class="main-content">
    <AppBar />
    <AboutUs />
    <Footer />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import AppBar from '@/components/AppBar.vue';
import AboutUs from "@/components/AboutUs.vue";
import Footer from "@/components/Footer.vue";

export default defineComponent({
  name: 'HomeView',

  components: {
    Footer,
    AboutUs,
    AppBar,
  },
});
</script>